module.exports = __webpack_public_path__ + "static/media/donut.1e1bb45a.png";